import { RootState } from '../../data/store'

export const getPracticesState = (state: RootState) => state?.practices
